import { Dialog } from '@chakra-ui/react';

interface BasicModalLayoutProps {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  title: string;
  closeOnOverlayClick?: boolean;
}

const BasicModalLayout = ({
  children,
  title,
  isOpen,
  closeOnOverlayClick = true,
  onClose,
}: BasicModalLayoutProps) => {
  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={(e) => !e.open && onClose()}
      closeOnInteractOutside={closeOnOverlayClick}
      placement="center"
      size="sm"
      motionPreset="slide-in-bottom"
    >
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content borderRadius={16} background="white">
          <Dialog.Header
            fontSize={{
              base: 18,
              md: 24,
            }}
            fontWeight="bold"
            pl={{ base: 5, md: 10 }}
            pr={{ base: 5, md: 10 }}
            pt={{ base: 5, md: 10 }}
            pb={{ base: 5, md: 6 }}
          >
            {title}
          </Dialog.Header>
          {closeOnOverlayClick && <Dialog.CloseTrigger />}
          <Dialog.Body p={{ base: 5, md: 10 }} pt={{ base: 0, md: 0 }}>
            {children}
          </Dialog.Body>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
};

export default BasicModalLayout;
